export const SITE = {
  brand: "Jyoti Graphics USA",
  legal: "Jyoti Graphics USA is operated by R&R Graphics LLC.",
  phone: "+1 561-313-9571",
  phoneHref: "tel:+15613139571",
  email: "jyotigraphics.print@gmail.com",
  emailHref: "mailto:jyotigraphics.print@gmail.com",
  address: "4956 Le Chalet Boulevard, Suite 13, Boynton Beach, FL 33436",
  addressLines: ["4956 Le Chalet Boulevard, Suite 13", "Boynton Beach, FL 33436"],
  hours: "Monday–Saturday, 10:00 AM–5:00 PM",
  headline: "Professional Printing, Backed by 30+ Years of Experience",
  sub: "From business cards and promotional materials to books and custom print projects, Jyoti Graphics USA provides dependable printing solutions tailored to your requirements.",
};

export const NAV = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/services" },
  { label: "Work", href: "/work" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" },
];

export const SERVICES = [
  {
    slug: "business-cards",
    number: "01",
    title: "Business Cards",
    tag: "Identity",
    blurb: "Refined finishes, premium stocks, and precision detail — the first handshake, in print.",
    features: ["Matte, gloss & soft-touch", "Foil stamping & embossing", "Rounded corners & spot UV"],
    image: "https://images.unsplash.com/photo-1777652918753-d66882b15391?fm=jpg&q=85&w=1600&auto=format&fit=crop",
  },
  {
    slug: "brochures-flyers",
    number: "02",
    title: "Brochures & Flyers",
    tag: "Marketing",
    blurb: "Tri-folds, bi-folds, and single-sheet flyers that communicate with clarity and colour.",
    features: ["Full-colour offset & digital", "Tri-fold, bi-fold, gate-fold", "Coated & uncoated stocks"],
    image: "https://images.unsplash.com/photo-1695634621121-691d54259d37?fm=jpg&q=85&w=1600&auto=format&fit=crop",
  },
  {
    slug: "books-booklets",
    number: "03",
    title: "Books & Booklets",
    tag: "Publishing",
    blurb: "Perfect-bound, saddle-stitched, spiral, and case-bound — from manuscript to shelf.",
    features: ["Perfect & saddle-stitch binding", "Hard & soft cover options", "Short-run & bulk quantities"],
    image: "https://plus.unsplash.com/premium_photo-1669652639337-c513cc42ead6?fm=jpg&q=85&w=1600&auto=format&fit=crop",
  },
  {
    slug: "promotional-materials",
    number: "04",
    title: "Promotional Materials",
    tag: "Brand",
    blurb: "Postcards, posters, calendars, stickers, and campaign collateral that command attention.",
    features: ["Posters & postcards", "Stickers & labels", "Calendars & campaign kits"],
    image: "https://plus.unsplash.com/premium_photo-1747956188670-b44b1cbc09bf?fm=jpg&q=85&w=1600&auto=format&fit=crop",
  },
  {
    slug: "banners-signage",
    number: "05",
    title: "Banners & Signage",
    tag: "Large Format",
    blurb: "Vinyl banners, retractable stands, and rigid signage engineered for indoor and outdoor use.",
    features: ["Vinyl & mesh banners", "Retractable & X-frame stands", "Rigid boards & foam-core"],
    image: "https://images.unsplash.com/photo-1593238404535-cda7ae2fe50b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    slug: "custom-print",
    number: "06",
    title: "Custom Print Projects",
    tag: "Bespoke",
    blurb: "Have something unusual in mind? We take on bespoke print projects with craft and care.",
    features: ["Bespoke sizes & stocks", "Speciality inks & finishes", "One-off & limited runs"],
    image: "https://plus.unsplash.com/premium_photo-1722686514121-2ab7a152454a?fm=jpg&q=85&w=1600&auto=format&fit=crop",
  },
];

export const PROCESS = [
  { n: "01", title: "Consult", body: "Share your project. We listen, ask the right questions, and recommend the stocks, finishes, and format that fit." },
  { n: "02", title: "Design & Proof", body: "Our team prepares your artwork, sends a print-ready proof, and refines details until every millimetre is right." },
  { n: "03", title: "Print", body: "Files go to press with careful colour management and quality checks at every step of the run." },
  { n: "04", title: "Deliver", body: "Finished, inspected, and packed with care — ready for pickup or delivery on your timeline." },
];

export const GALLERY = [
  { src: "/images/business-cards.jpg", cat: "Business Cards" },
  { src: "https://images.unsplash.com/photo-1707989515908-a3f3095fbb8d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", cat: "Brochures" },
  { src: "https://images.unsplash.com/photo-1531072901881-d644216d4bf9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", cat: "Books" },
  { src: "https://images.unsplash.com/photo-1503694978374-8a2fa686963a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", cat: "Press Detail" },
  { src: "https://images.unsplash.com/photo-1593238404535-cda7ae2fe50b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", cat: "Signage" },
  { src: "https://images.unsplash.com/photo-1516409590654-e8d51fc2d25c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", cat: "Custom Print" },
  { src: "https://images.unsplash.com/photo-1516387938699-a93567ec168e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", cat: "Promotional" },
  { src: "https://images.unsplash.com/photo-1568667256549-094345857637?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", cat: "Booklets" },
];

export const TRUST = [
  { k: "30+", v: "Years of printing experience" },
  { k: "6", v: "Core service categories" },
  { k: "100%", v: "Owner-reviewed proofs" },
  { k: "1:1", v: "Direct client communication" },
];
